import { pushToDataLayer } from '../../pushToDataLayer';
import { GTMEvent, GTMEventAttributes, GTMEventName } from '../../types';

export function addVideoAttributeEvent() {
  const eventAttributes: GTMEventAttributes = {
    event: GTMEvent.COVIDEO_EVENT,
    event_name: GTMEventName.ADD_VIDEO_ATTRIBUTES,
  };

  pushToDataLayer({
    ...eventAttributes,
  });
}
